export default {"src":"/_next/static/media/stepdivider.cdaf8185.svg","height":62,"width":2,"blurWidth":0,"blurHeight":0};